"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/tag/v1/admin_tag_error.proto (package spwn.tag.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTagHasAssociationError = exports.TagAssociationType = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.tag.v1.TagAssociationType
 */
var TagAssociationType;
(function (TagAssociationType) {
    /**
     * @generated from enum value: TAG_ASSOCIATION_TYPE_UNSPECIFIED = 0;
     */
    TagAssociationType[TagAssociationType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * グッズに紐づいている
     *
     * @generated from enum value: TAG_ASSOCIATION_TYPE_GOODS = 1;
     */
    TagAssociationType[TagAssociationType["GOODS"] = 1] = "GOODS";
})(TagAssociationType = exports.TagAssociationType || (exports.TagAssociationType = {}));
// Retrieve enum metadata with: proto3.getEnumType(TagAssociationType)
protobuf_1.proto3.util.setEnumType(TagAssociationType, "spwn.tag.v1.TagAssociationType", [
    { no: 0, name: "TAG_ASSOCIATION_TYPE_UNSPECIFIED" },
    { no: 1, name: "TAG_ASSOCIATION_TYPE_GOODS" },
]);
/**
 * タグがグッズやチケットに紐づいている場合削除できない
 *
 * @generated from message spwn.tag.v1.AdminTagHasAssociationError
 */
class AdminTagHasAssociationError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.tag.v1.TagAssociationType association_type = 1;
         */
        this.associationType = TagAssociationType.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTagHasAssociationError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTagHasAssociationError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTagHasAssociationError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTagHasAssociationError, a, b);
    }
}
exports.AdminTagHasAssociationError = AdminTagHasAssociationError;
AdminTagHasAssociationError.runtime = protobuf_1.proto3;
AdminTagHasAssociationError.typeName = "spwn.tag.v1.AdminTagHasAssociationError";
AdminTagHasAssociationError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "association_type", kind: "enum", T: protobuf_1.proto3.getEnumType(TagAssociationType) },
]);
//# sourceMappingURL=admin_tag_error_pb.js.map